// imports
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import axios from 'axios'

import { AREAS, DISTRICTS, DIVISIONS, ORGANIZATIONS, SUB_CATEGORY, WISHLISTS } from '../../../Utilities/APIs'
import OrganizationFilter from './OrganizationFilter/OrganizationFilter'
import OrganizationList from './OrganizationList/OrganizationList'

import './AllOrganizations.css'

function Organizations() {

    // states
    const { subCategoryId } = useParams()
    const {consumer} = useSelector(state => state.auth)
    const [selectedSubcategory, setSelectedSubcategory] = useState(null)

    const [organizationsInSubcategory, setOrganizationsInSubcategory] = useState(null)
    const [displayOrganizations, setDisplayOrganizations] = useState(null)
    const [searchOrgs, setSearchOrgs] = useState(null)
    const [searchQuery, setSearchQuery] = useState('')

    const [divisions, setDivisions] = useState(null)
    const [districts, setDistricts] = useState(null)
    const [areas, setAreas] = useState(null)

    const [selectedDivision, setSelectedDivision] = useState('all-divisions')
    const [selectedDistrict, setSelectedDistrict] = useState('all-districts')
    const [selectedArea, setSelectedArea] = useState('all-areas')

    const [selectedCost, setSelectedCost] = useState('all-costs')

    const [toggleFetch, setToggleFetch] = useState(false)

    // useEffects
    useEffect(() => {
        async function getAndSetOrganizationsFromSubcategory() {
            const {data} = await axios.get(ORGANIZATIONS + 'getOrganizationsFromsubcategory/' + subCategoryId)
            setOrganizationsInSubcategory(data)
        }

        getAndSetOrganizationsFromSubcategory()

        async function getAndSetSubcategory() {
            const subcatRes = await fetch(SUB_CATEGORY)
            const subcatData = await subcatRes.json()
            const selSubcat = subcatData.find(s => s._id === subCategoryId)
            setSelectedSubcategory(selSubcat)
        }

        getAndSetSubcategory()
    }, [subCategoryId])
    
    useEffect(() => {
        async function getAndSetDivisions() {
            const divisionsRes = await fetch(DIVISIONS)
            const divisionsData = await divisionsRes.json()
            setDivisions(divisionsData)
        }
        getAndSetDivisions()

        async function getAndSetDistricts() {
            const districtsRes = await fetch(DISTRICTS)
            const districtsData = await districtsRes.json()
            setDistricts(districtsData)
        }
        getAndSetDistricts()

        async function getAndSetAreas() {
            const areasRes = await fetch(AREAS)
            const areasData = await areasRes.json()
            setAreas(areasData)
        }
        getAndSetAreas()
    }, [])

    useEffect(() => {
        async function getAndSetOrganizations() {
            let filteredOrgs
            if (organizationsInSubcategory && selectedCost) {
                if (selectedCost === 'all-costs') {
                    filteredOrgs = organizationsInSubcategory
                } else {
                    filteredOrgs = organizationsInSubcategory.filter(o => o.cost === parseInt(selectedCost))
                }
            }
            let displayData
            if (consumer) {
                const config = {
                    headers: {
                        Authorization: `Bearer ${consumer.token}`
                    }
                }
                const {data} = await axios.get(WISHLISTS + 'myWishlist', config)
                const wishData = data.map(d => d.organization)
                displayData = filteredOrgs.map(org => org = {...org, favorite: wishData.includes(org._id)})
            } else {
                displayData = filteredOrgs
            }
            setDisplayOrganizations(displayData)
        }
        getAndSetOrganizations()
    }, [organizationsInSubcategory, selectedCost, consumer, toggleFetch])

    useEffect(() => {
        if (displayOrganizations) {
            if (searchQuery === '') {
                setSearchOrgs(displayOrganizations)
            }
            if (searchQuery !== '') {
                setSearchOrgs(displayOrganizations.filter(o => (o.name.includes(searchQuery) || o.engName.includes(searchQuery))))
            }
        }
    }, [searchQuery, displayOrganizations])

    function triggerFetch() {
        setToggleFetch(prevState => !prevState)
    }

    //small device filter toggle
    const [filterShow, setFilterShow] = useState(false);
    const handleFilterShow = () =>{
        setFilterShow(true);
    }
    const handleFilterHide = () =>{
        setFilterShow(false);
    }


    return (
        <>
            <section className="organizations_page ss_page">
                <div className="container">
                    <div className="row filtered_content">

                        <OrganizationFilter

                            selectedDivision={selectedDivision}
                            setSelectedDivision={setSelectedDivision}
                            selectedDistrict={selectedDistrict}
                            setSelectedDistrict={setSelectedDistrict}
                            selectedArea={selectedArea}
                            setSelectedArea={setSelectedArea}
                            divisions={divisions}
                            districts={districts}
                            areas={areas}

                            selectedCost={selectedCost}
                            setSelectedCost={setSelectedCost}

                            filterShow={filterShow}
                            handleFilterHide={handleFilterHide}

                        />
                        
                        <OrganizationList 

                            selectedSubcategory={selectedSubcategory}
                            searchOrgs={searchOrgs}
                            triggerFetch={triggerFetch}

                            handleFilterShow={handleFilterShow}

                            searchQuery={searchQuery}
                            setSearchQuery={setSearchQuery}

                        />

                    </div>
                </div>
            </section>
        </>
    )
}

export default Organizations